const transformCurrency = (currency) => (currency === 'GBP' ? '£' : '');

export default transformCurrency;
